export default function AircraftCompareButton({ items, onPress }) {
    return (
        <div className="el-sorting__compare">
            <a role='button' className="el-sorting__compare-link"
                onClick={onPress}>
                <i className="icon-compare2"></i>
                {items.length > 0 &&
                    <b style={{ display: 'inline' }}>{items.length}</b>}
                <span>{tMsg('Сравнение')}</span>
            </a>
        </div>
    )
}
